export default "__VITE_ASSET__0fe49a84__"